import { FormItemRule } from '@components/Form/FormItem/FormItem';

export const Validators = {
  required: (message?: string): FormItemRule => ({
    required: true,
    message: message ?? 'Это поле обязательно для заполнения',
  }),
  coordinates: (message?: string): FormItemRule => ({
    pattern: /^(?=.{1,20}$)-?\d{1,3}(\.\d+)?$/,
    message: message ?? 'Введите корректную широту или долготу (например, 52.249076)',
  }),
  whitespace: (): FormItemRule => ({
    whitespace: true,
    message: 'Значение поля не может содержать в себе только пробелы',
  }),
  unp: () => ({
    pattern: /^[1-9]\d{8}$/,
    message: 'УНП должен содержать 9 цифр и не начинаться с 0',
  }),
  licenseNumber: (): FormItemRule => ({
    pattern: /^\d{14}$/,
    message: 'Номер лицензии должен содержать 14 цифр',
  }),
  email: (): FormItemRule => ({
    pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    message: 'Введите корректный E-mail',
  }),
  passportSeries: (): FormItemRule => ({
    pattern: /^[A-Z,А-Я]{2,5}$/,
    message: 'Должно быть от двух до пять заглавных букв (например, AB)',
  }),
  birthCertificate: (): FormItemRule => ({
    pattern: /^[IVXLCDM]-[А-Я]{2}$/,
    message: 'Должно быть в формате I-АЛ (I – римская цифра, АЛ – две буквы)',
  }),
  identificationNumber: (): FormItemRule => ({
    pattern: /^[0-9][0-9]{6}[A-Z][0-9]{3}[A-Z]{2}[0-9]$/,
    message: 'Должно быть в формате "X XXXXXX Z ХХХ ZZ X"',
  }),
  number: (): FormItemRule => ({
    pattern: /^[A-Za-z0-9]{1,25}$/,
    message:
      'Номер может содержать только латинские символы и цифры, длина - до 25 символов.',
  }),
  postIndex: (): FormItemRule => ({
    pattern: /^\d{6}$/,
    message: 'Почтовый индекс должен содержать 6 цифр',
  }),
  phone: (): FormItemRule => ({
    pattern: /\+375[0-9]{9}/g,
    message: 'Неверный формат номера телефона. Пример: +375291111111',
  }),
  roleName: (): FormItemRule => ({
    pattern: /^[a-z0-9_-]+$/,
    message:
      'Имя роли должно содержать только латинские буквы в нижнем регистре, цифры, дефисы и подчеркивания',
  }),
  specialSymbolsValidation: (): FormItemRule => ({
    pattern: /^[A-Za-zА-Яа-яЁё0-9\s.,-]+$/,
    message: 'Значение поля не может содержать символы / * + @ # $ % ^ ()',
  }),
  specialSymbolsValidationWithoutNumber: (): FormItemRule => ({
    pattern: /^[A-Za-zА-Яа-яЁё\s.,-]+$/,
    message: 'Значение поля не может содержать цифры и символы / * + @ # $ % ^ ()',
  }),
  integerFrom0To100: (message?: string): FormItemRule => ({
    pattern: /^(100|[1-9]?\d)$/,
    message: message ?? 'Введите целое число от 0 до 100',
  }),
};
